import apiClient from './client';
import type { User, SingleResponse } from '@/types';

export interface LoginCredentials { username: string; password: string; }
export interface LoginResponse    { user: User; token: string; }

export const authApi = {
  login:  (credentials: LoginCredentials) =>
    apiClient.post<SingleResponse<LoginResponse>>('/auth/login', credentials).then(r => r.data.data),

  logout: () =>
    apiClient.post('/auth/logout').then(r => r.data),

  me: () =>
    apiClient.get<SingleResponse<User>>('/auth/me').then(r => r.data.data),
};
